import { useMutation, useQuery } from '@tanstack/react-query'
import { postNamedCommand, postNamedQuery } from '../service'

export const useStartBlueprintExportMutation = () => {
  return useMutation({
    mutationFn: async (params) => {
      const { data } = await postNamedCommand('coreData', 'start-blueprint-export', params)
      return data
    }
  })
}

export const useGetExportQuery = (exportId, options = {}) => {
  const { enabled = true, refetchInterval = false } = options
  return useQuery({
    queryKey: ['get-export', exportId],
    queryFn: async () => {
      const { data } = await postNamedQuery('coreData', 'get-export', { exportId })
      return data
    },
    enabled: enabled && !!exportId,
    refetchInterval
  })
}
